export default __webpack_public_path__ + "static/media/appraise1.56b0a7c9.png";